import { ToastContainer } from 'react-toastify';
import RouterData from './Routes';
import { AuthProvider } from './Context/AuthContext';

function App() {
  return (
    <AuthProvider>
      <RouterData />
      <ToastContainer />
    </AuthProvider>
  );
}

export default App;
